/**
 * Routes.
 * @module routes
 */

import { App, Search } from '@plone/volto/components';
import { defaultRoutes, multilingualRoutes } from '@plone/volto/routes';
import config from '@plone/volto/registry';

export const italiaRoutes = [
  // Add design-comuni-plone-theme routes here
  {
    path: '/**/search',
    component: Search,
  },
];

/**
 * Routes array.
 * @array
 * @returns {array} Routes.
 */

const filteredRoutes = defaultRoutes.filter(
  (item) => item.path !== '/contact-form',
);

const routes = [
  {
    path: '/',
    component: App, // Change this if you want a different component
    routes: [
      ...italiaRoutes,
      ...(config.addonRoutes || []),
      ...((config.settings?.isMultilingual && multilingualRoutes) || []),
      ...filteredRoutes,
    ],
  },
];

export default routes;
